var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 16,
    viewBox: "0 0 37 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    width: 36,
    height: 16,
    rx: 8,
    fill: "#D81717"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4743 5V11H12.3356L9.00582 6.91309H8.94716V11H7.66699V5H8.81258L12.1389 9.08984H12.201V5H13.4743Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8692 11V5H19.4654V5.91113H16.1494V7.54004H19.2273V8.45117H16.1494V10.0889H19.493V11H14.8692Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2586 11L20.2642 5H21.641L22.9142 9.40918H22.9798L24.3393 5H25.5919L26.9548 9.41211H27.017L28.2902 5H29.667L27.6726 11H26.4097L24.9949 6.79004H24.9397L23.5215 11H22.2586Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNew);
export default __webpack_public_path__ + "static/media/ic-new.ec59973c5b8800bb24e042cd29392efb.svg";
export { ForwardRef as ReactComponent };